import * as React from 'react';
import { RegionCard } from '@ui/components';

import './CountriesList.less';

interface Props {
  countries: any[];
  onClick: (country: any) => void;
}

const CountriesList: React.FunctionComponent<Props> = ({
  countries,
  onClick,
}) => (
  <div className="countries-list">
    {countries.map(country => (
      <RegionCard key={country.id} region={country} onClick={onClick} />
    ))}
  </div>
);

export default CountriesList;



// WEBPACK FOOTER //
// ./src/scenes/Countries/components/CountriesList/CountriesList.tsx